import type { ApiClient } from '@sentinel/api-client';
import { clearExpiresAt } from './access-token-refresh';

export async function logout(client: ApiClient): Promise<void> {
  try {
    await client.POST('/auth/logout' as any, {} as any);
  } finally {
    clearExpiresAt();
  }
}
